import React from "react";
import AlertNotification from "./AlertNotification";

export default () => <AlertNotification />;
